import { useTranslations } from 'next-intl';

import { EventTicketStatus } from '@/enums/enums';
import { OrderStatus } from '@/types/order';

type BadgeType = 'private' | 'soldOut' | 'serviceTable' | 'notAvailable';

const BADGE_TYPES: {
  [k in OrderStatus | BadgeType | EventTicketStatus]: {
    name: string;
    className: string;
  };
} = {
  private: {
    name: 'private',
    className: 'text-[#6BA7FC] bg-[#071326]',
  },
  soldOut: { name: 'soldOut', className: 'text-[#ED7FAB] bg-out-red-faded' },
  notAvailable: {
    name: 'notAvailable',
    className: 'text-white-neutral-faded bg-neutral-faded-default',
  },
  serviceTable: {
    name: 'serviceTable',
    className: 'text-[#EF70A1] bg-[#230712]',
  },
  delivered: {
    name: 'delivered',
    className: 'text-positive-filled-hover bg-positive-faded-disabled',
  },
  cancelled: {
    name: 'cancelled',
    className: 'text-neutral-filled-bold bg-neutral-faded-disabled',
  },
  [EventTicketStatus.canceled]: {
    name: 'cancelled',
    className: 'text-neutral-filled-bold bg-neutral-faded-disabled',
  },
  ongoing: {
    name: 'ongoing',
    className: 'text-warning-filled-hover bg-warning-faded-disabled',
  },
  waiting: {
    name: 'waiting',
    className: 'text-warning-filled-hover bg-warning-faded-disabled',
  },
  paid: {
    name: 'paid',
    className: 'text-warning-filled-hover bg-warning-faded-disabled',
  },
  created: {
    name: 'created',
    className: 'text-warning-filled-hover bg-warning-faded-disabled',
  },
  pending: {
    name: 'pending',
    className: 'text-warning-filled-hover bg-warning-faded-disabled',
  },
  accepted: {
    name: 'accepted',
    className: 'text-warning-filled-hover bg-warning-faded-disabled',
  },
  used: {
    name: 'used',
    className: 'text-positive-filled-hover bg-positive-faded-disabled',
  },
  refunded: {
    name: 'refunded',
    className: 'text-neutral-filled-hover bg-neutral-faded-disabled',
  },
};

interface BadgeProps {
  type: keyof typeof BADGE_TYPES;
  text?: string;
  count?: number;
}
export default function Badge({ type, text, count }: BadgeProps) {
  const t = useTranslations('Components.UI.Badge');

  return (
    <div
      className={`${BADGE_TYPES[type].className} rounded-md px-2 py-1 text-sm font-bold`}
    >
      <p>
        {text
          ? text
          : count
            ? `${count} ${t(BADGE_TYPES[type].name)}`
            : t(BADGE_TYPES[type].name)}
      </p>
    </div>
  );
}
